import { render, staticRenderFns } from "./CustomizeAddChapterPop.vue?vue&type=template&id=63877bf4"
import script from "./CustomizeAddChapterPop.vue?vue&type=script&lang=js"
export * from "./CustomizeAddChapterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports